export const MAIN: any = {
    APP: {
        BRAND: 'MyMatrix-FileUpload'
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/shared/constant/main.ts